import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { addMinutes, differenceInMinutes, subMinutes } from 'date-fns';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TransferType } from '../types';
import { ShiftTransferTimePickerHelperService } from '../shift-transfer-time-picker-helper.service';
import { UseLocalizedDateFormatDirective } from '@wilson/localization';

@Component({
  selector: 'wilson-transfer-by-time',
  templateUrl: './transfer-by-time.component.html',
  styleUrls: ['./transfer-by-time.component.scss'],
  imports: [
    TranslateModule,
    NzInputModule,
    NzDatePickerModule,
    FormsModule,
    UseLocalizedDateFormatDirective,
  ],
  providers: [ShiftTransferTimePickerHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferByTimeComponent implements OnInit, OnChanges {
  protected readonly shiftTransferTimePickerHelperService = inject(
    ShiftTransferTimePickerHelperService,
  );

  @Input() previousShiftEndDateTime!: string;
  @Input() nextShiftStartDateTime!: string;
  @Input() selectedTransferType!: TransferType;

  @Output() durationChange = new EventEmitter<number>();
  @Output() selectedDateTimeChange = new EventEmitter<Date>();

  protected TransferType = TransferType;
  protected selectedStartDateTime!: string;
  protected selectedEndDateTime!: string;
  protected isInvalid = false;

  ngOnInit(): void {
    this.shiftTransferTimePickerHelperService.startDateTime =
      this.previousShiftEndDateTime;
    this.shiftTransferTimePickerHelperService.endDateTime =
      this.nextShiftStartDateTime;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTransferType']) {
      if (this.selectedTransferType === TransferType.Previous) {
        this.selectedStartDateTime = this.previousShiftEndDateTime;
        this.selectedEndDateTime = addMinutes(
          new Date(this.previousShiftEndDateTime),
          60,
        ).toISOString();
      } else if (this.selectedTransferType === TransferType.Next) {
        this.selectedStartDateTime = subMinutes(
          new Date(this.nextShiftStartDateTime),
          60,
        ).toISOString();
        this.selectedEndDateTime = this.nextShiftStartDateTime;
      } else if (this.selectedTransferType === TransferType.New) {
        this.selectedStartDateTime = this.previousShiftEndDateTime;
        this.selectedEndDateTime = this.nextShiftStartDateTime;
        this.generateTransferDateTime();
      }
      this.shiftTransferTimePickerHelperService.selectedStartDateTime =
        this.selectedStartDateTime;
    }
  }

  generateTransferDateTime(): void {
    if (this.selectedStartDateTime && this.selectedEndDateTime) {
      this.shiftTransferTimePickerHelperService.selectedStartDateTime =
        this.selectedStartDateTime;

      const duration = differenceInMinutes(
        new Date(this.selectedEndDateTime),
        new Date(this.selectedStartDateTime),
      );
      this.isInvalid = duration < 0;
      this.durationChange.emit(this.isInvalid ? 0 : duration);
      if (this.selectedTransferType === TransferType.New) {
        this.selectedDateTimeChange.emit(new Date(this.selectedStartDateTime));
      }
    } else {
      this.durationChange.emit(0);
    }
  }
}
